<script>
  import Wysiwyg from '$lib/default/Wysiwyg.svelte';
  export let content;
</script>

<div class="section-wysiwyg container">
  <Wysiwyg {content} />
</div>

<style lang="scss">
  .section-wysiwyg {
    margin: 10rem auto;

    @include resp-max('s') {
      margin: 5rem auto;
    }
  }
</style>
